
import BlankLayout from "@/layouts/BlankLayout.vue";
import DefaultLayouts from "@/layouts/DefaultLayouts.vue";


const routes = [
  {
    path:'/',
    component:DefaultLayouts,
    // component:()=> import('@/modules/workorder/pages/index/index.vue'),
    children:[
      {
        path: '/',
        component:() => import('@/pages/index.vue'),
        meta:{title:'空投项目信息网'},
      },
      {
        path: '/article',
        name:'articleList',
        component:() => import('@/pages/article_list.vue'),
        meta:{title:'文章列表'},
      },
      {
        path: '/article/detail',
        name:'articleDetail',
        component:() => import('@/pages/article_detail.vue'),
        meta:{title:'文章详情'},
      },
      {
        path: '/project',
        name:'projectList',
        component:() => import('@/pages/project_list.vue'),
        meta:{title:'文章列表'},
      },
      {
        path: '/project/detail',
        name:'projectDetail',
        component:() => import('@/pages/project_detail.vue'),
        meta:{title:'文章详情'},
      },
      {
        path: '/login',
        name:'login',
        component:() => import('@/pages/login.vue'),
        meta:{title:'登录'},
      },
    ]
  },
  // {
  //   path:'/login',
  //   component:BlankLayout,
  //   children:[
  //     {
  //       path: '/login/index',
  //       name:'login',
  //       component:() => import('@/pages/login.vue'),
  //     },
  //
  //   ]
  // },
]
export default routes